// extracted by mini-css-extract-plugin
module.exports = {"inputBox":"styles_inputBox__1kL7J","inputRow":"styles_inputRow__1zG_z","submit":"styles_submit__2dx30","accepted":"styles_accepted__IUFT_","spin":"styles_spin__X0VVl"};